import { Grid, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ customStyle: any }>()((theme, { customStyle }) => ({
	subtitle: {
		color: theme.palette.text.secondary,
		...customStyle?.subtitle
	},
	content: {
		color: theme.palette.text.primary,
		wordBreak: 'break-word',
		textAlign: 'right',
		...customStyle?.content
	},
	container: {
		display: 'grid',
		gridTemplateColumns: '1fr auto',
		gap: 8,
		...customStyle?.container
	}
}));

const DetailsGridColumns = (props) => {
	const { data, customStyle, isLoading } = props;
	const { classes } = useStyles({ customStyle });

	return data?.map((item, index) => {
		const { subTitle, content, subtitleVariant, subtitleClassName, contentVariant, contentClassName } = item;

		return (
			<Grid item key={`${subTitle}-${index}`} className={!isLoading && classes.container}>
				{isLoading ? (
					<Skeleton />
				) : (
					<>
						<Typography variant={subtitleVariant || 'body2'} className={subtitleClassName || classes.subtitle}>
							{subTitle}
						</Typography>
						<Typography component="div" variant={contentVariant || 'body1'} className={contentClassName || classes.content}>
							{content}
						</Typography>
					</>
				)}
			</Grid>
		);
	});
};

export default DetailsGridColumns;
